/**@jsx jsx */
import { jsx, Box } from 'theme-ui'
import { graphql } from 'gatsby'
import CompanyLanding from '../components/company-landing'
import Layout from '../components/layout'

export const query = graphql`
  query($slug: String!) {
    jobPosting(slug: { eq: $slug }) {
      frontmatter {
        banner
        blurb
        company_name
        company_benefits
        company_values
        image_1
        tech_stack
        interview_process
        company_benefits
        company_about
        diversity
        equity
        inclusion
        safe_space
        leadership
        industry_contribution
        company_website
        company_facebook
        company_linkedin
        company_twitter
        company_insta
        company_image
        company_team
        logo
        live
        roles {
          role_location
          role_title
          role_type
          role_url
          salary_start
          salary_end
        }
        benefits {
          benefit
        }
        vetting_process {
          process
        }
        image_2
        image_3
        image_4
        image_5
        meta_image
      }
    }
    mdx(slug: { regex: $slug }) {
      body
    }
  }
`

const CompanyLandingTemplate = ({ data, pageContext }) => {
  const isLive = data.jobPosting.frontmatter.live
  if (!isLive) {
    return (
      <Layout shouldExcludeFooter={true}>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px'}}>
        <h1>This page is not live at the moment</h1>
        </div>
      </Layout>
    )
  }

  return (
    <Box>
      <CompanyLanding
        frontmatter={data.jobPosting.frontmatter}
        mdx={data.mdx}
      />
    </Box>
  )
}

export default CompanyLandingTemplate
